import template from './review-order.html';
export var ReviewOrderComponent = {
    template: template,
    controller: /** @class */ (function () {
        function ReviewOrderComponent($rootScope, $scope, CartService) {
            'ngInject';
            this.cart = null;
            this.errors = {
                havePageErrors: false,
                pageErrors: '',
                pageErrorType: ''
            };
            this.loadingBar = true;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.CartService = CartService;
        }
        ReviewOrderComponent.prototype.$onInit = function () {
            var _this = this;
            this.CartService.updateDeliveryOption();
            var updatingPricingWatch = this.$rootScope.$watch('updatingPricing', function (newVal) {
                if (!newVal) {
                    updatingPricingWatch(); // destroy watch
                    var isNewRequest = true;
                    _this.CartService.subscribe(_this.$scope, function (event, cart) {
                        _this.cart = Object.assign({}, cart);
                        _this.loadingBar = false;
                    }, isNewRequest);
                }
            });
        };
        return ReviewOrderComponent;
    }())
};
//# sourceMappingURL=review-order.component.js.map